import React, { useState, useEffect } from 'react';

// const API_BASE_URL = 'http://localhost:8080';
const API_BASE_URL = 'https://sardar-jewellers.com';

const AdminOrderList: React.FC = () => {
    const [orders, setOrders] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    
    // Popup ke liye states
    const [selectedOrder, setSelectedOrder] = useState<any | null>(null);
    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const [addressDetails, setAddressDetails] = useState<any>(null);
    const [isLoadingDetails, setIsLoadingDetails] = useState(false);

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/all-admin`);
            if (response.ok) {
                const data = await response.json();
                setOrders(data);
            }
        } catch (error) {
            console.error("Error fetching admin orders", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleStatusChange = async (orderId: number, newStatus: string, e: React.ChangeEvent<HTMLSelectElement>) => {
        e.stopPropagation(); // Row click aur Dropdown click ko alag rakhne ke liye
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/update-status/${orderId}?status=${newStatus}`, { method: 'PUT' });
            if (response.ok) {
                setOrders(prev => prev.map(o => o.orderId === orderId ? { ...o, status: newStatus } : o));
                if (selectedOrder && selectedOrder.orderId === orderId) {
                    setSelectedOrder({ ...selectedOrder, status: newStatus });
                }
            } else { alert("Failed to update status."); }
        } catch (error) { console.error("Error updating status", error); }
    };

    // Row par click karne se Popup open hoga aur details fetch hongi
    const openOrderDetails = async (order: any) => {
        setSelectedOrder(order);
        setIsLoadingDetails(true);
        setCustomerDetails(null);
        setAddressDetails(null);

        try {
            // 1. Asli User Data nikal rahe hain backend se
            const userRes = await fetch(`${API_BASE_URL}/api/users/${order.userSrno}`);
            if (userRes.ok) {
                const userData = await userRes.json();
                setCustomerDetails({
                    name: userData.userName || "User",
                    email: userData.emailId || "No Email",
                    phone: userData.mobileNo || "No Number"
                });
            }

            // 2. Asli Address Data nikal rahe hain tumhari Profile API se
            const addressRes = await fetch(`${API_BASE_URL}/api/user-profile/address/${order.userSrno}`);
            if (addressRes.ok) {
                const allAddresses = await addressRes.json();
                const matchedAddress = allAddresses.find((a: any) => a.addressId === order.addressId);
                if (matchedAddress) {
                    setAddressDetails(matchedAddress);
                }
            }
        } catch (error) {
            console.error("Error fetching full details", error);
        } finally {
            setIsLoadingDetails(false);
        }
    };

    const closeModal = () => setSelectedOrder(null);

    if (isLoading) return <div className="p-10 text-center font-bold">Loading Orders...</div>;

    return (
        <div className="p-6 bg-white rounded-lg shadow-md m-4 relative">
            <h2 className="text-2xl font-bold mb-6 text-gray-800 border-b pb-2">Manage All Orders</h2>
            
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                    <thead className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                        <tr>
                            <th className="py-3 px-6 text-left">Order ID</th>
                            <th className="py-3 px-6 text-left">Date</th>
                            <th className="py-3 px-6 text-left">Items</th>
                            <th className="py-3 px-6 text-right">Amount</th>
                            <th className="py-3 px-6 text-center">Status</th>
                            <th className="py-3 px-6 text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-700 text-sm font-light">
                        {orders.map((order) => (
                            <tr 
                                key={order.orderId} 
                                onClick={() => openOrderDetails(order)} 
                                className="border-b border-gray-200 hover:bg-amber-50 cursor-pointer transition"
                            >
                                <td className="py-3 px-6 text-left font-bold text-amber-800">#{order.orderId}</td>
                                <td className="py-3 px-6 text-left">{new Date(order.orderDate).toLocaleDateString()}</td>
                                <td className="py-3 px-6 text-left">
                                    <span className="bg-gray-200 text-gray-700 py-1 px-2 rounded text-xs font-bold">{order.items?.length} Items</span>
                                </td>
                                <td className="py-3 px-6 text-right font-bold">₹{order.totalAmount?.toFixed(2)}</td>
                                <td className="py-3 px-6 text-center">
                                    <span className={`py-1 px-3 rounded-full text-xs font-bold 
                                        ${order.status === 'CANCELLED' ? 'bg-red-100 text-red-700' : 
                                          order.status === 'DELIVERED' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                                        {order.status}
                                    </span>
                                </td>
                                <td className="py-3 px-6 text-center" onClick={(e) => e.stopPropagation()}>
                                    <select 
                                        value={order.status}
                                        onChange={(e) => handleStatusChange(order.orderId, e.target.value, e)}
                                        className="border border-gray-300 rounded px-2 py-1 outline-none focus:ring-1 focus:ring-amber-500 font-medium text-sm cursor-pointer"
                                    >
                                        <option value="PLACED">Placed</option>
                                        <option value="SHIPPED">Shipped</option>
                                        <option value="OUT FOR DELIVERY">Out for Delivery</option>
                                        <option value="DELIVERED">Delivered</option>
                                        <option value="CANCELLED">Cancelled</option>
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modal / Popup Design */}
            {selectedOrder && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 transition-opacity">
                    <div className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-4xl max-h-[90vh] flex flex-col overflow-hidden animate-fade-in-up">
                        
                        <div className="px-6 py-4 border-b bg-gray-50 flex justify-between items-center">
                            <div>
                                <h3 className="text-2xl font-bold text-gray-800">Order Details <span className="text-amber-700">#{selectedOrder.orderId}</span></h3>
                                <p className="text-sm text-gray-500 mt-1">Placed on: {new Date(selectedOrder.orderDate).toLocaleString()}</p>
                            </div>
                            <button onClick={closeModal} className="text-gray-400 hover:text-red-500 text-3xl font-bold transition">&times;</button>
                        </div>

                        <div className="p-6 overflow-y-auto flex-grow bg-gray-50/50">
                            {isLoadingDetails ? (
                                <div className="text-center py-10 text-gray-500 font-medium">Fetching complete details...</div>
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    
                                    <div className="space-y-6">
                                        <div className="bg-white p-5 rounded-xl border shadow-sm">
                                            <h4 className="font-bold text-gray-800 border-b pb-2 mb-3 text-lg flex items-center gap-2">👤 Customer Details</h4>
                                            {customerDetails ? (
                                                <div className="space-y-2 text-sm">
                                                    <p><span className="text-gray-500 w-20 inline-block">Name:</span> <span className="font-semibold">{customerDetails.name}</span></p>
                                                    <p><span className="text-gray-500 w-20 inline-block">Phone:</span> <span className="font-semibold">{customerDetails.phone}</span></p>
                                                    <p><span className="text-gray-500 w-20 inline-block">Email:</span> <span>{customerDetails.email}</span></p>
                                                </div>
                                            ) : <p className="text-sm text-gray-500">User Data not found</p>}
                                        </div>

                                        <div className="bg-white p-5 rounded-xl border shadow-sm">
                                            <h4 className="font-bold text-gray-800 border-b pb-2 mb-3 text-lg flex items-center gap-2">📍 Delivery Address</h4>
                                            {addressDetails ? (
                                                <div className="text-sm space-y-1">
                                                    <p className="font-bold text-gray-800">{addressDetails.fullName}</p>
                                                    <p className="text-gray-600">{addressDetails.streetAddress}</p>
                                                    <p className="text-gray-600">{addressDetails.city}, {addressDetails.state} - <span className="font-bold text-gray-800">{addressDetails.pincode}</span></p>
                                                </div>
                                            ) : <p className="text-sm text-gray-500">Address not found</p>}
                                        </div>
                                    </div>

                                    <div className="bg-white p-5 rounded-xl border shadow-sm flex flex-col">
                                        <h4 className="font-bold text-gray-800 border-b pb-2 mb-3 text-lg flex items-center gap-2">🛍️ Order Items</h4>
                                        <div className="flex-grow overflow-y-auto pr-2 space-y-3">
                                            {selectedOrder.items?.map((item: any, idx: number) => (
                                                <div key={idx} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border">
                                                    <div className="w-16 h-16 bg-white border rounded flex items-center justify-center overflow-hidden flex-shrink-0">
                                                        {item.productImage ? <img src={item.productImage} alt="Product" className="w-full h-full object-cover" /> : <span className="text-xl">📦</span>}
                                                    </div>
                                                    <div className="flex-grow">
                                                        <p className="font-semibold text-gray-800 text-sm line-clamp-2">{item.productTitle || "Product Item"}</p>
                                                        <p className="text-xs text-gray-500 mt-1">Qty: <span className="font-bold">{item.quantity}</span></p>
                                                    </div>
                                                    <div className="text-right font-bold text-amber-700">
                                                        ₹{(item.price * item.quantity).toFixed(2)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mt-4 pt-3 border-t flex justify-between items-center text-lg">
                                            <span className="font-bold text-gray-600">Total Amount:</span>
                                            <span className="font-extrabold text-green-600 text-xl">₹{selectedOrder.totalAmount?.toFixed(2)}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminOrderList;